<template>
  <small v-if="event" class="p-1">Reference ID: <span>{{event.reference_id}}</span></small>
</template>
<script>
export default {
  props: [ 'event' ]
}
</script>
